<template>
    <DRow>
        <DCol>
            <DTabs class="mb-3">
                <DTabItem
                    id="monitor-tab"
                    :route-url="route('tools.bankruptcy-monitor.index')"
                    :active="['tools.bankruptcy-monitor.index'].includes(route().current())"
                    :label="__('tools.bankruptcy_monitor.index.tab')"
                />
                <DTabItem
                    id="history-tab"
                    :route-url="route('tools.bankruptcy-monitor.history')"
                    :active="['tools.bankruptcy-monitor.history'].includes(route().current())"
                    :label="__('tools.bankruptcy_monitor.history.tab')"
                />
            </DTabs>
        </DCol>
    </DRow>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
</script>
